var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-sm",attrs:{"to":{ name: 'post',  params: { post: _vm.url }}}},[_vm._v(_vm._s(_vm.name || 'Читать дальше'))])}
var staticRenderFns = []

export { render, staticRenderFns }